import { Box, Typography } from "@mui/material";
import React from "react";

import { type IconName } from "../Icon";
import { StyledIcon, StyledIconContainer } from "../PasswordStrengthIndicator";

export type OktaPasswordStrengthIndicatorItemProps = {
  ruleKey: string;
  label: string;
  isValid: boolean;
  shouldShowResult: boolean;
};

const computeValidationDisplay = ({
  isValid,
  shouldShowResult,
  label,
}: OktaPasswordStrengthIndicatorItemProps) => {
  if (!shouldShowResult) {
    return {
      iconColor: "gray.subnavTab",
      textColor: "gray.subnavTab",
      iconName: "check" as IconName,
      message: label,
      isValid: false,
    };
  }

  return {
    iconColor: isValid ? "success.main" : "error.main",
    textColor: isValid ? "secondary.main" : "error.main",
    iconName: (isValid ? "check" : "clear") as IconName,
    message: label,
    isValid,
  };
};

export const OktaPasswordStrengthIndicatorListItem = (
  props: OktaPasswordStrengthIndicatorItemProps
) => {
  const { ruleKey } = props;
  const { iconColor, textColor, iconName, message, isValid } = computeValidationDisplay(props);

  return (
    <Box
      data-cy-password-test={ruleKey}
      data-cy-password-valid={isValid}
      sx={{ display: "flex", alignItems: "center", mt: 1 }}
    >
      <StyledIconContainer
        aria-live="polite"
        aria-atomic="true"
        sx={{ backgroundColor: iconColor }}
      >
        <StyledIcon name={iconName} />
      </StyledIconContainer>
      <Typography
        sx={{
          fontWeight: "bold",
          color: textColor,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
